import BuildBrand from "./BuildBrand";

const BuildFooter = () => {
  return (
    <footer className="apl-footer">
      <div className="apl-shell apl-footer-row">
        <BuildBrand />
        <p className="apl-footer-copy">
          Real business problems deserve working products—not more technology
          theatre. © 2026 Utiva.
        </p>
        <div className="apl-footer-links">
          <a href="https://utiva.co/">Utiva.co</a>
          <a href="mailto:info@utiva.io">info@utiva.io</a>
        </div>
      </div>
    </footer>
  );
};

export default BuildFooter;
